exports.components = {
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-inclusive-stories-js": () => import("./../../../src/pages/inclusive-stories.js" /* webpackChunkName: "component---src-pages-inclusive-stories-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-profiles-js": () => import("./../../../src/pages/profiles.js" /* webpackChunkName: "component---src-pages-profiles-js" */),
  "component---src-pages-selector-js": () => import("./../../../src/pages/selector.js" /* webpackChunkName: "component---src-pages-selector-js" */)
}

